 import React, { useCallback } from "react";
import { SERVER_URL } from "../config/config.js";
import "./biltyReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useLocation, useHistory } from "react-router-dom";
import { useEffect } from "react";
import { mrStatementGroupInfo } from "../config/CrossingOutBillReport.js";
let ex_data = [];

function CrossingOutBiltyWise({ sessionObject }) {
  const history = useHistory();
  const columns = React.useMemo(
    () => [
      {
        Header: "Crossing Outward No",
        accessor: "crossing_outward_no",
        width: "150px",
        minWidth: "150px",
        canFilter: true,
      },
      {
        Header: "Crossing Outward Date",
        accessor: "crossing_outward_date",
        width: "150px",
        minWidth: "150px",
        canFilter: true,
      },
      {
        Header: "Transporter Name",
        accessor: "transporter_name",
        width: "180px",
        minWidth: "180px",
        canFilter: true,
      },
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
        width: "180px",
        minWidth: "180px",
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
        width: "180px",
        minWidth: "180px",
      },
      {
        Header: "Station Name",
        accessor: "station_name",
        canFilter: true,
        width: "180px",
        minWidth: "180px",
      },
      {
        Header: "Pkgs",
        accessor: "no_of_package",
        canFilter: true,
        width: "80px",
        minWidth: "80px",
      },
      {
        Header: "Item Names",
        accessor: "item_names",
        canFilter: true,
        width: "100px",
        minWidth: "100px",
      },
      {
        Header: "Crossing Hire",
        accessor: "crossing_hire",
        canFilter: true,
        width: "100px",
        minWidth: "100px",
      },
      {
        Header: "To Pay Amount",
        accessor: "to_pay_amount",
        canFilter: true,
        width: "100px",
        minWidth: "100px",
      },
      {
        Header: "Paid Amount",
        accessor: "paid_amount",
        canFilter: true,
        width: "100px",
        minWidth: "100px",
      },
    ],
    []
  );

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const fetchIdRef = React.useRef(0);
  const download_ref = React.useRef(null);
  const [dateState, setDateState] = React.useState({
    date_from: new Date(),
    date_to: new Date(),
    in_stock: "Y",
  });

  const [pageState, setPageState] = React.useState({
    total_amount: 0,
    total_net_amount: 0,
    total_bilties: 0,
  });
  const [finalInput, setFinalInput] = React.useState({});
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let query = useQuery();

  useEffect(() => {
    const reportType = query.get("report_type");
    setDateState({
      ...dateState,
      ["report_type"]: reportType,
    });
  }, []);

  const fetchData = useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      const fetchId = ++fetchIdRef.current;

      try {
        for (let key in customFilters) {
          console.log("Key", customFilters[key].toLowerCase(), key);
          if (customFilters[key].toLowerCase() == "none") {
            customFilters[key] = null;
          }
        }
        setLoading(true);

        if (fetchId === fetchIdRef.current) {
          let newObject = {};

          newObject.created_from = String(
            sessionObject.sessionVariables.branch_id
          );

          newObject = { ...newObject, ...customFilters };

          let inputData = {
            paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
            sort_fields: sortBy,
            filter_fields: newObject,
            date_dict: {
              date_from: dateObject.date_from,
              date_to: dateObject.date_to,
            },
          };

          setFinalInput(inputData);

          let response = await fetch(
            SERVER_URL + "/crossing_outward/report_print_bilty_data",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(inputData),
            }
          );

          let resp = await response.json();

          let setObj = {};
          if (resp["data"] && "total_rows" in resp) {
            let tableData = [];

            if (Array.isArray(resp.data)) {
              tableData = resp.data;
            }
            else if (resp.data && typeof resp.data === "object") {
              const nestedArrayKeys = Object.keys(resp.data).filter((key) =>
                Array.isArray(resp.data[key])
              );
              if (nestedArrayKeys.length > 0) {
                tableData = resp.data[nestedArrayKeys[0]];
              }
            }

            setData(tableData);
            setPageCount(Math.ceil(resp["total_rows"] / pageSize));

            setObj = {
              total_amount: resp["total_amount"],
              total_net_amount: resp["total_net_amount"],
              total_bilties: resp["total_rows"],
            };
            setPageState({ ...pageState, ...setObj });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return (
    <div className="report-bilty">
      <div className="form-header">Crossing Out Bilty Wise Report</div>
      <div className="report-bilty-table-container">
        <div className="report-field-row ">
          <div>
            From Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_from}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_from"]: date,
                })
              }
            />
          </div>
          <div>
            To Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_to}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_to"]: date,
                })
              }
            />
          </div>
        </div>
        <div className="chform-row">
          {mrStatementGroupInfo["group-1"].map(function (info) {
            return (
              <div className={info["className"]} key={info["name"]}>
                <label className={info["labelClassName"]}>
                  {info["label"]}:
                </label>
                <input
                  size="8"
                  disabled={true}
                  type={info["type"]}
                  value={pageState[info["name"]]}
                />
                {/* </label> */}
              </div>
            );
          })}
        </div>
        <ReportTable
          columns={columns}
          data={data}
          fetchData={fetchData}
          dateObject={dateState}
          loading={loading}
          pageCount={pageCount}
          canView={true}
          // handleViewClick={handleViewClick}
        />
        {
          <div className="form-footer">
            <button style={{ display: "none" }}>
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-table-xls-button"
                table="crossingout_biltywise_report_excel"
                filename="tablexls"
                sheet="tablexls"
                buttonText="Download as XLS"
                ref={(a) => (download_ref.current = a)}
              />
            </button>

            <button
              className="download-table-xls-button"
              onClick={async () => {
                setLoading(true);
                try {
                  let dataToSend = {
                    date_dict: finalInput.date_dict,
                    filter_fields: finalInput.filter_fields,
                  };
                  let url = SERVER_URL + "/crossing_outward/report_print_bilty_data";

                  let resp = await fetch(url, {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToSend),
                  });

                  if (!resp.ok) {
                    throw new Error(`HTTP error! status: ${resp.status}`);
                  }

                  let response = await resp.json();
                  console.log("API response:", response);

                  if (response?.data?.crossing_data && "total_rows" in response) {
                    ex_data = response.data.crossing_data;
                  } else {
                    console.log("Unexpected response format", response);
                    ex_data = [];
                  }
                } catch (error) {
                  console.log("Error fetching report data:", error);
                  ex_data = [];
                } finally {
                  setLoading(false);
                  download_ref.current?.handleDownload();
                }
              }}
            >
              Download as XLS
            </button>
            {ReportExcel.crossingout_bilty_wise_excel_data(
              { columns },
              { ex_data },
              { fetchData },
              { dateState },
              { loading },
              { pageCount },
              { dateState }
            )}
          </div>
        }
      </div>
    </div>
  );
}

export default CrossingOutBiltyWise;
